import React, { useState, useEffect } from 'react';

import FileSaver from 'file-saver';

import { deleteDocumentsForSummary, getUploadedDocumentsForSummary, uploadDocumentsForSummary } from 'home/view/manage-feasibility/services';

import { getFromSessionStorage } from 'common/utils/app.utils';

import { MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN, DEFAULT_TOAST_MSG, ERROR_TOAST } from 'home/view/manage-feasibility/constants';

import { validateFileAndGetFormData } from 'common/utils/validator';
import { isOrderConfirmationUrl } from 'dedicated/services/summary.service';
import upload_icon from 'dedicated/components/images/upload_icon.svg';
import uploading_icon from 'dedicated/components/images/uploading.svg';
import { getFileName } from 'home/view/manage-feasibility/utils';
import { isAOIOrder } from 'common/constants/app.constants';

const FileUpload = ({
  containerClassname = '',
  labelClassname = '',
  onFileUploadSuccess,
  label,
  supportedLabel,
  limitLabel,
  fileSchema,
  multiple,
  type,
  defaultFiles = [],
  setToast = () => {},
  isOrderConfirmation = false
}) => {
  const [isUploaded, setIsUploaded] = useState(false);
  const [error, setError] = useState({ state: false, message: '' });
  const [files, setFiles] = useState([]);
  const [progressValue, setProgressValue] = useState(0);

  const summaryAuthToken = getFromSessionStorage(MULTI_SITE_MODULE_ID, SUMMARY_AUTH_TOKEN);

  useEffect(() => {
    if (defaultFiles.length > 0) {
      setIsUploaded(true);
      setFiles(defaultFiles);
    }
  }, [defaultFiles]);

  useEffect(() => {
    if (files && files.length > 0 && isUploaded) {
      onFileUploadSuccess('success', type, Array.from(files));
    } else {
      onFileUploadSuccess('', type, []);
    }
  }, [isUploaded]);

  const onUploadProgress = (progressEvent) => {
    const loadingPercentage = (progressEvent.loaded / progressEvent.total) * 100;
    setProgressValue(loadingPercentage - 5);
  };

  const myFileUpload = async (event) => {
    const { isFilesValid, formData, errorMessage, filesMetaData } = validateFileAndGetFormData({ event, ...fileSchema, files });

    if (isFilesValid) {
      const uploadedFiles = [...files, ...Array.from(filesMetaData)];
      setFiles(uploadedFiles);
      setError({ state: false, message: '' });

      try {
        const { res, err } = await uploadDocumentsForSummary(formData, summaryAuthToken, onUploadProgress);

        if (res) {
          const { data: { success = false } = {} } = res;

          if (success) {
            setProgressValue(100);
            setIsUploaded(true);
            setTimeout(() => setProgressValue(0));
          }
        } else if (err) {
          const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

          setProgressValue(0);
          setIsUploaded(false);
          setFiles([]);
          setError({
            state: true,
            message: errorMsg
          });
          throw new Error(errorMsg);
        }
      } catch (e) {
        console.error(e);
      }
    } else {
      setError({
        state: true,
        message: errorMessage
      });
    }
  };

  const getUploadedFile = async (documentName, type) => {
    const payload = { documentType: fileSchema.documentType, documentName };

    try {
      const { res, err } = await getUploadedDocumentsForSummary(payload, summaryAuthToken);

      if (res) {
        const { data } = res;
        const file = new Blob([data], { type });
        // view files in new tab
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL, '_blank');

        // for downloading files
        // const fileName = getFileName(res, 'PO_DOC.PDF');
        // const file = new Blob([data], { type });
        // FileSaver.saveAs(file, fileName);
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setError({
          state: true,
          message: errorMsg || 'Error while opening files'
        });

        setToast(true, errorMsg, ERROR_TOAST);

        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const onDeleteUploadedFile = async (fileName, documentName) => {
    const payload = { documentType: fileSchema.documentType, documentName };

    setError({ state: false, message: '' });

    try {
      const { res, err } = await deleteDocumentsForSummary(payload, summaryAuthToken);

      if (res) {
        const leftFiles = files.filter(({ documentName: fileDocumentName }) => fileDocumentName !== documentName);
        setFiles(leftFiles);
        if (leftFiles.length === 0) {
          setIsUploaded(false);
        }
      } else if (err) {
        const errorMsg = (err && err.response && err.response.data && err.response.data.errorMsg) || DEFAULT_TOAST_MSG;

        setError({
          state: true,
          message: errorMsg || 'Error while deleting files'
        });

        setToast(true, errorMsg, ERROR_TOAST);

        throw new Error(errorMsg);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const renderUploadedFiles = () => {
    return files.map(({ name, size, type, documentName }, index) => {
      return (
        <div className="file_content" key={name + index}>
          <span className="file_icon">
            <img src={uploading_icon} alt="Uploading" />
          </span>
          <a className="name_text" role="button" href onClick={getUploadedFile.bind(null, documentName, type)}>
            {name}
          </a>
          {!isOrderConfirmation && <span className="cross_icon" onClick={onDeleteUploadedFile.bind(null, name, documentName)}></span>}
        </div>
      );
    });
  };

  const getListOfFiles = () => {
    return files.map(({ name }) => name).join(', ');
  };

  return (
    <React.Fragment>
      {
        <React.Fragment>
          {error.state && <div className="msg_strip strip_error">Error: {error.message}</div>}

          {!isAOIOrder() && !error.state && isUploaded && !isOrderConfirmationUrl() && <div className="msg_strip strip_success">{getListOfFiles()} successfully uploaded</div>}

          {
            <div className={`upload_status ${containerClassname}`}>
              <ul className="attach_types">
                <li className={labelClassname}> {label}</li>
                <li> {supportedLabel} </li>
                <li> {limitLabel} </li>
              </ul>
              {files?.length < fileSchema?.documentNames?.length && (
                <div className="file_upload_area">
                  <div className="select_files">
                    <span class="upload_file_iocn">
                      <img src={upload_icon} alt="Upload" />
                    </span>
                    <div className="upload_text">
                      Drag a file here to attach or <span class={`link ${isOrderConfirmation ? 'disabled' : ''}`}>browse</span>
                    </div>
                    {multiple ? (
                      <input className="upload_field" type="file" disabled={isOrderConfirmation} onChange={myFileUpload} accept={fileSchema.supportedTypes.join(',')} multiple />
                    ) : (
                      <input className="upload_field" type="file" onChange={myFileUpload} accept={fileSchema.supportedTypes.join(',')} />
                    )}
                  </div>
                </div>
              )}
              <div className="progress_bar">
                <div className="progress_line" style={{ width: `${progressValue}%` }}></div>
              </div>

              {isUploaded && renderUploadedFiles()}
            </div>
          }
        </React.Fragment>
      }
    </React.Fragment>
  );
};

export default FileUpload;
